import * as serverReq from "./settingsCrud";
import {settingsSlice} from "./settingsSlice";
import {errorMessage} from "../../../../util/Helpers"

const {actions} = settingsSlice;


/* Api Request Error Handler */
const errorHandler = dispatch => error => {
  
  dispatch(actions.settingsNotification({ notification: {type: "error", message: errorMessage(error)}}));
}

export const clearNotification = _ => dispatch => dispatch(actions.settingsNotification({notification: null}));

/********************************
 * Webhook CRUD Operations
 ****************************************************************/

/* Load Webhooks Action */
export const fetchWebhooks = _ => dispatch => {
  serverReq.getAllWebhooks()
            .then(({data}) =>  dispatch(actions.webhooksFetched({ data })))
            .catch(errorHandler(dispatch));
};

/* Add new Webhook Action */
export const addWebhook = webhookData => dispatch => {
  serverReq.addWebhook(webhookData)
            .then(({data}) => {
              dispatch(fetchWebhooks());
              dispatch(actions.webhookCreated({data}));
            })
            .catch(errorHandler(dispatch));
};

/* Update existing webhook Action */
export const updateWebhook = webhookData => dispatch => {
  serverReq.updateWebhook(webhookData)
            .then(({data}) => dispatch(actions.webhookUpdated({data})))
            .catch(errorHandler(dispatch));
};

/* Delete existing webhook Action */
export const deleteWebhook = id => dispatch => {
  serverReq.deleteWebhook(id)
            .then(({data}) => dispatch(actions.webhookDeleted({ data })))
            .catch(errorHandler(dispatch));
};
